// Simple hook to read query parameters from the current URL.

import { useLocation } from 'react-router-dom';

/**
 * useQuery
 * Returns a URLSearchParams instance for the current location.search.
 * Note:
 * - URLSearchParams provides get(), set(), has(), entries(), etc.
 * - This hook will re-run when the route changes (location.search updates).
 * Usage:
 *   const query = useQuery();
 *   const lightTouch = query.get('light-touch'); // e.g. "true" | "false" | null
 */
export function useQuery() {
  // useLocation() gives access to the current route info (pathname, search, hash).
  // We construct URLSearchParams from the "search" string which contains query params.
  return new URLSearchParams(useLocation().search);
}